import React from 'react';
import { compose } from 'react-apollo';
import Navbar from 'react-bootstrap/Navbar';
import { withRouter } from 'react-router-dom';
import PatronAssetsContainer from 'containers/PatronAssetsContainer';
import PatronAssetsDisplay from 'components/PatronAssetsDisplay';
import SupportButton from 'components/SupportButton';
import RootClasses from 'utils/RootClasses';
import withSuppressAsSecondaryContent from 'utils/withSuppressAsSecondaryContent';
import './Footer.css';

function Footer() {
  return (
    <div className="footer">
      <RootClasses className="with-footer" />
      <Navbar fixed="bottom" aria-label="Footer">
        <PatronAssetsContainer>
          <PatronAssetsDisplay />
        </PatronAssetsContainer>
        <div className="footer-spacer" />
        <SupportButton withReportGameIssue className="d-min-md" />
      </Navbar>
    </div>
  );
}

export default compose(withRouter, withSuppressAsSecondaryContent)(Footer);
